import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { HOME_IMAGES } from '../../constants/images';
import { ScrollReveal } from '../ui/ScrollReveal';

const ServicesSection = () => {
  const points = [
    'ISO 9001:2015 & ISO 45001:2018 Certified',
    '27+ years of proven industry expertise',
    'Trusted by 100+ leading companies',
    '4300+ skilled professionals pan-India',
    'Complete end-to-end project solutions',
    'On-time delivery with zero-compromise quality',
  ];

  return (
    <section id="services" className="py-12 sm:py-16 md:py-20 lg:py-24 bg-[#FAF8F2] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 md:gap-16 items-center">
          <ScrollReveal variant="fadeRight" threshold={0.2}>
            <div className="relative group">
              <div className="overflow-hidden rounded-sm">
                <motion.img
                  src={HOME_IMAGES.industry}
                  alt="Why industry leaders choose us"
                  className="w-full h-[300px] sm:h-[350px] md:h-[400px] lg:h-[450px] object-cover"
                  whileHover={{ scale: 1.03 }}
                  transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                />
              </div>
              <motion.div
                className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-[#8B7355] text-white p-4 sm:p-6"
                initial={{ opacity: 0, x: 20, y: 20 }}
                whileInView={{ opacity: 1, x: 0, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ delay: 0.4, duration: 0.5 }}
              >
                <div className="text-2xl sm:text-3xl md:text-4xl font-light mb-1">ISO</div>
                <div className="text-xs sm:text-sm">9001:2015 Certified</div>
              </motion.div>
            </div>
          </ScrollReveal>

          <ScrollReveal variant="fadeLeft" threshold={0.2}>
            <div>
              <h3 className="font-serif text-2xl sm:text-3xl text-[#1A1A1A] mb-6 sm:mb-8">
                Why industry leaders choose us
              </h3>
              <ul className="space-y-3 sm:space-y-4">
                {points.map((point, index) => (
                  <motion.li
                    key={index}
                    className="flex items-start sm:items-center gap-3 sm:gap-4 group"
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.1 + index * 0.08 }}
                  >
                    <span className="w-7 h-7 sm:w-8 sm:h-8 bg-[#8B7355]/10 flex items-center justify-center group-hover:bg-[#8B7355] transition-colors duration-300 flex-shrink-0 mt-0.5 sm:mt-0">
                      <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#8B7355] group-hover:text-white transition-colors" />
                    </span>
                    <span className="text-sm sm:text-base text-[#1A1A1A]">{point}</span>
                  </motion.li>
                ))}
              </ul>

              <p className="text-[#6B6B65] text-sm sm:text-base mt-6 leading-relaxed">
                From refineries to power plants and industrial facilities nationwide, our portfolio showcases the breadth of our expertise. See how we've delivered for industry leaders.
              </p>

              <Link
                to="/projects"
                className="inline-flex items-center gap-2 mt-4 text-sm sm:text-base text-[#8B7355] font-medium hover:gap-3 transition-all group"
              >
                Explore all our projects
                <span className="inline-block group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
